import React from "react";
import Banner from "../../components/Banner";
import { Sidebar } from "../../components/Sidebar";
import Spinner from "../../components/Spinner";
import axios from "axios";
import { API } from "./../../utils/helper";
import fileDownload from "js-file-download";

export default class BulkUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      importsList: [],
      categories: [],
      subcategories: [],
      assetTypes: [],
      category: "",
      subcategory: "",
      assetType: "",

      companyProfileId: sessionStorage.getItem("companyProfileId") || "0",

      errors: {},
      uploadFile: null,
      uploadAssetType: "",
      loading: false,
      msg: "",
      toastColor: "",
    };
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.loadDropdowns = this.loadDropdowns.bind(this);
    this.fetchTemplate = this.fetchTemplate.bind(this);
    this.fetchImportsList = this.fetchImportsList.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    this.loadDropdowns(token);
    this.fetchImportsList();
  }

  loadDropdowns(token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + "/asset/getassetdropdownlist", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const data = response.data || {};
        let subcategories = [];
        const categories = data.categorys
          ? data.categorys.map((cat) => {
              subcategories.push(...cat.subcategorys);
              return { name: cat.name, subcategories: cat.subcategorys };
            })
          : [];
        let assetTypes = new Set();
        subcategories?.forEach((sub) => {
          assetTypes.add(sub.assetType);
        });

        this.setState({
          categories: categories,
          assetTypes: assetTypes,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to load dropdowns.",
          toastColor: "danger",
        });
      });
  }

  fetchTemplate() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    axios
      .get(API + `/asset/templatedownload/${this.state.assetType}`, {
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        fileDownload(response.data, this.state.assetType + "_TEMPLATE.xlsx");
        this.setState({
          loading: false,
          category: "",
          subcategory: "",
          assetType: "",
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to download template.",
          toastColor: "danger",
        });
      })
      .finally(() =>
        this.setState({
          loading: false,
        })
      );
  }

  fetchImportsList() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    axios
      .get(API + `/asset/getassetimportlist/${this.state.companyProfileId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        this.setState({
          loading: false,
          importsList: response.data,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to fetch list.",
          toastColor: "danger",
        });
      })
      .finally(() =>
        this.setState({
          loading: false,
        })
      );
  }

  loadSubcategories(categoryName) {
    let subcategories =
      this.state.categories?.find((cat) => cat.name === categoryName)
        .subcategories || [];
    this.setState({ subcategories });
  }

  handleFileChange(e) {
    const file = e.target.files ? e.target.files[0] : null;
    this.setState({ uploadFile: file });
  }

  handleSelectChange(name, value) {
    this.setState({ [name]: value }, () => {
      if (name === "category") {
        this.loadSubcategories(value);
      }
      if (name === "subcategory") {
        const subcategory = this.state.subcategories.find(
          (sub) => Number(sub.id) === Number(this.state.subcategory)
        );
        this.setState({ assetType: subcategory.assetType });
      }
    });
  }

  handleUpload(e) {
    e.preventDefault();
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    if (!Number(this.state.companyProfileId)) {
      this.setState({
        msg: "Account is not a company profile, action not allowed",
        toastColor: "danger",
      });
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    const request = new FormData();
    request.append("file", this.state.uploadFile);

    axios
      .post(API + `/asset/importsave/${this.state.companyProfileId}`, request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        let toastColor = "";
        let msg = "";
        if (response.data.success) {
          toastColor = "success";
          msg = "Import successful";
          setTimeout(() => {
            this.fetchImportsList();
          }, 5000);
        } else {
          toastColor = "danger";
          msg = "Import failed - " + response.data.message;
        }
        this.setState({
          msg: msg,
          toastColor: toastColor,
          loading: false,
          uploadFile: null,
          uploadAssetType: "",
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to load upload file.",
          toastColor: "danger",
        });
      })
      .finally(() =>
        this.setState({
          loading: false,
        })
      );
  }

  render() {
    const s = this.state;

    let divMsg = null;
    if (this.state.msg) {
      divMsg = (
        <div
          className={
            this.state.toastColor === "success"
              ? "alert alert-success mx-7"
              : this.state.toastColor === "danger"
              ? "alert alert-danger mx-7"
              : "alert alert-info mx-7"
          }
        >
          {this.state.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-vh-100 d-flex bg-white">
        <Sidebar />
        <div className="min-vh-100 flex-grow-1 d-flex flex-column">
          <Banner title="Bulk Upload" />
          {divMsg}

          <div className="rounded-bottom d-flex flex-column align-items-center mx-7">
            <div className="d-flex gap-2 mb-2 w-100">
              <div className="input-group">
                <label className="input-group-text">Category</label>
                <select
                  name="category"
                  className={`form-control ${
                    s.errors.category ? " !border-red-500" : ""
                  }`}
                  value={s.category}
                  onChange={(e) =>
                    this.handleSelectChange("category", e.target.value)
                  }
                  required
                >
                  <option value="">Select</option>
                  {s.categories.map((cat) => (
                    <option key={cat.name} value={cat.name}>
                      {cat.name}
                    </option>
                  ))}
                </select>
                {s.errors.category && (
                  <span className="input-group-error">{s.errors.category}</span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Subcategory</label>
                <select
                  name="subcategory"
                  className={`form-control ${
                    s.errors.subcategory ? " !border-red-500" : ""
                  }`}
                  value={s.subcategory}
                  onChange={(e) =>
                    this.handleSelectChange("subcategory", e.target.value)
                  }
                  required
                >
                  <option value="">Select</option>
                  {s.subcategories.map((sub) => (
                    <option key={`subcategory-${sub.id}`} value={sub.id}>
                      {sub.name}
                    </option>
                  ))}
                </select>
                {s.errors.subcategory && (
                  <span className="input-group-error">
                    {s.errors.subcategory}
                  </span>
                )}
              </div>
              <button
                className="btn btn-primary text-nowrap !w-[23rem]"
                disabled={!s.subcategory}
                onClick={this.fetchTemplate}
              >
                Download Template
              </button>
            </div>

            <form
              onSubmit={this.handleUpload}
              className="d-flex gap-2 mb-4 w-100"
            >
              <div className="input-group">
                <label className="input-group-text">Upload File</label>
                <input
                  className="form-control"
                  type="file"
                  name="uploadFile"
                  onChange={this.handleFileChange}
                  accept=".xlsx"
                />
              </div>
              <div className="input-group"></div>
              <button
                disabled={!s.uploadFile}
                type="submit"
                className="btn btn-primary w-23rem"
                onClick={this.handleUpload}
              >
                Upload
              </button>
            </form>

            <div className="w-100 overflow-auto border rounded-2">
              <table className="w-100 table table-striped table-hover rounded-2">
                <thead className="table-primary">
                  <tr>
                    <th className="px-4 py-3 text-start small fw-medium text-muted">
                      File Number
                    </th>
                    <th className="px-4 py-3 text-start small fw-medium text-muted">
                      File Name
                    </th>
                    <th className="px-4 py-3 text-start small fw-medium text-muted">
                      Date Time
                    </th>
                    <th className="px-4 py-3 text-start small fw-medium text-muted">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {s.importsList.map((item) => (
                    <tr key={`record-${item.id}`}>
                      <td className="px-4 py-4 text-nowrap text-dark">
                        {item.id}
                      </td>
                      <td className="px-4 py-4 text-nowrap text-dark">
                        {item.originalFilename}
                      </td>
                      <td className="px-4 py-4 text-nowrap text-dark">
                        {item.creation_date_time}
                      </td>
                      <td className="px-4 py-4 text-nowrap text-dark">
                        {item.assetImportStatus}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {s.importsList.length === 0 && (
                <div className="text-muted text-center py-4">
                  No import records found.
                </div>
              )}
            </div>
          </div>

          
        </div>
      </div>
    );
  }
}
